import React from 'react'
import { Row, Col, Divider, Typography, Card, Space } from 'antd'
import {
    RocketOutlined,
    SafetyCertificateOutlined,
    AppstoreOutlined,
} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const { Paragraph } = Typography

const Home: React.FC = () => {
    const { t } = useTranslation(['home', 'navigation'])

    return (
        <div className="home-container">
            <Row gutter={[0, 48]}>
                {/* 头部区域 */}
                <Col span={24} className="text-center">
                    <Space direction="vertical" size="large">
                        <Paragraph
                            type="secondary"
                            style={{ fontSize: '18px' }}
                        >
                            {t('home:subtitle')}
                        </Paragraph>
                    </Space>
                    <Divider />
                </Col>
                {/* 特性介绍区域 */}
                <Col span={24}>
                    <Divider orientation="left">{t('home:features.sectionTitle')}</Divider>
                    <Row gutter={[24, 24]}>
                        <Col span={24} md={8}>
                            <Card
                                title={t('home:features.efficient.title')}
                                variant="borderless"
                                className="feature-card"
                                extra={<RocketOutlined />}
                            >
                                {t('home:features.efficient.description')}
                            </Card>
                        </Col>
                        <Col span={24} md={8}>
                            <Card
                                title={t('home:features.accurate.title')}
                                variant="borderless"
                                className="feature-card"
                                extra={<SafetyCertificateOutlined />}
                            >
                                {t('home:features.accurate.description')}
                            </Card>
                        </Col>
                        <Col span={24} md={8}>
                            <Card
                                title={t('home:features.comprehensive.title')}
                                variant="borderless"
                                className="feature-card"
                                extra={<AppstoreOutlined />}
                            >
                                {t('home:features.comprehensive.description')}
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </div>
    )
}

export default Home
